import {Action} from "../../../actions/actions";
import {SpecialPrizesPresetsActionTypes} from "../actions/actionTypes";
import _ from "lodash";

export function presetsList(state: any[] = [], action: Action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
            case SpecialPrizesPresetsActionTypes.GET_PRESETS_SUCCESS:
            return {
                presets: action.payload.results,
                count: action.payload.count,
                timestamp: new Date(
                    new Date().getTime() || 0
                ).toLocaleTimeString()
            };
        case SpecialPrizesPresetsActionTypes.TOGGLE_CERTIFIED_PRESET_SUCCESS:
            const indexCertified = _.findIndex(newState.presets, [
                "id",
                action.payload.presetId
            ]);
            if (indexCertified > -1) {
                newState.presets[indexCertified].certified = action.payload.certified;
            }
            return newState;
        case SpecialPrizesPresetsActionTypes.TOGGLE_PRESET_ACTIVE_SUCCESS:
            const index = _.findIndex(newState.presets, [
                "id",
                action.payload.presetId
            ]);
            if (index > -1) {
                newState.presets[index].active = action.payload.active;
            }
            return newState;
        default:
            return state;
    }
}

export function presetsLoading(state: boolean = false, action: Action): boolean {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.GET_PRESETS:
            return true;
        case SpecialPrizesPresetsActionTypes.GET_PRESETS_SUCCESS:
        case SpecialPrizesPresetsActionTypes.GET_PRESETS_FAIL:
            return false;
        default:
            return state;
    }
}

export function presetLoading(state: boolean = false, action: Action): boolean {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.GET_PRESET:
            return true;
        case SpecialPrizesPresetsActionTypes.GET_PRESET_SUCCESS:
        case SpecialPrizesPresetsActionTypes.GET_PRESET_FAIL:
            return false;
        default:
            return state;
    }
}

export function initialPreset(state: any = {}, action: Action) {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.CLEAR_PRESET:
            return {};
        case SpecialPrizesPresetsActionTypes.GET_PRESET_SUCCESS:

            let preset = {
                ...action.payload,
                type: parseInt(action.payload.type)
            };

            const convertibleFields = [
                "contribution",
                "max_value",
                "increment_sound_value",
                "initial_value",
                "prize_gold_value",
                "prize_silver_value",
                "prize_bronze_value",
                "start_percentage",
                "min_sort",
                "max_sort"
            ];

            preset.settings && Object.keys(preset.settings).map((key, index)=>{
                if(convertibleFields.includes(key)){
                    preset.settings[key]=preset.settings[key] / 100
                }
            })
            return preset;
        default:
            return state;
    }
}

export function submitPresetLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.ADD_PRESET:
            return true;
        case SpecialPrizesPresetsActionTypes.ADD_PRESET_SUCCESS:
        case SpecialPrizesPresetsActionTypes.ADD_PRESET_FAIL:
            return false;
        default:
            return state;
    }
}

export function submittingPresetState(
    state: {
        error: boolean;
        success: boolean;
        message: string | null;
    } | null = null,
    action: Action
): {
    error: boolean;
    success: boolean;
    message: string | null;
} | null {
    switch (action.type) {
        case SpecialPrizesPresetsActionTypes.CLEAR_PRESET:
        case SpecialPrizesPresetsActionTypes.CLEAR_SUBMIT_PRESET:
            return null;
        case SpecialPrizesPresetsActionTypes.ADD_PRESET_SUCCESS:
            return {
                error: false,
                success: true,
                message: null
            };
        case SpecialPrizesPresetsActionTypes.ADD_PRESET_FAIL:
            return {
                error: true,
                success: false,
                message: action.payload.text ? action.payload.text : null
            };
        default:
            return state;
    }
}
